import { gql } from "@apollo/client";
import { FeedComponentInfo } from "./getFeedComponentsCall";

export const GET_FEED_CURVES_INFO = gql`
  query GetPanelFeedCurvesInfo($domain: String!, $input: PanelBasicQueryInfoInput!) {
    getPanelFeedCurvesInfo(domain: $domain, input: $input) {
      id
      name
      default
      active
      milestones {
        milestone
        startDay
      }
      mixture {
        day
        component
        amount
      }
    }
  }
`;

export type Milestone = {
  milestone: string;
  startDay: number;
};


export type MixtureComponent = {
  day: number;
  component: FeedComponentInfo['id'];
  amount: number;
};

export type FeedCurveInfo = {
  id: number;
  name: string;
  default: boolean;
  active: boolean;
  milestones: Milestone[];
  mixture: MixtureComponent[];
};
 
export interface FeedCurvesResponse {
  getPanelFeedCurvesInfo: FeedCurveInfo[]
}
